import classnames from 'classnames';
import PropTypes from 'prop-types';
import React, { useEffect, useRef } from 'react';
import Button from 'react-bootstrap/Button';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const StyledButton = styled(Button)`
  flex: 1 1 0;
  :not(:last-child) {
    margin-right: 0.3em;
  }
`;

const Question = ({
  questionId, answer, onAnswer, scrollToQuestion,
}) => {
  const { t } = useTranslation(['commons', 'questions']);
  const questionRef = useRef(null);
  const AlternativeBtn = ({ children, value, ...props }) => {
    const active = answer === value;
    return (
      <StyledButton
        {...props}
        variant={active ? 'primary' : null}
        className={classnames({ border: !active })}
        onClick={() => onAnswer(value)}
      >
        {children}
      </StyledButton>
    );
  };
  useEffect(() => {
    if (scrollToQuestion) {
      window.scrollTo({
        top: questionId === 1 ? 0 : questionRef.current.offsetTop + 100,
        behavior: 'smooth',
      });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div ref={questionRef} data-test-id="questionContainer" className="shadow px-3 py-4 mb-4 bg-white">
      <h5 className="font-weight-bold">{t(`questions:${questionId}`)}</h5>
      <div className="mt-3">
        <div className="d-flex mb-2">
          <AlternativeBtn value={1}>{t('alternatives.veryDifficult')}</AlternativeBtn>
          <AlternativeBtn value={2}>{t('alternatives.difficult')}</AlternativeBtn>
        </div>
        <div className="d-flex">
          <AlternativeBtn value={3}>{t('alternatives.easy')}</AlternativeBtn>
          <AlternativeBtn value={4}>{t('alternatives.veryEasy')}</AlternativeBtn>
        </div>
      </div>
    </div>
  );
};

Question.propTypes = {
  answer: PropTypes.number,
  questionId: PropTypes.number.isRequired,
  onAnswer: PropTypes.func.isRequired,
  scrollToQuestion: PropTypes.bool,
};

export default Question;
